import * as React from "react";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {
    CONTROLROOM_TABLE_HEADER_HEIGHT,
    CONTROLROOM_TABLE_ROW_HEIGHT,
    createBasicTableComponent,
} from "../../common/ui/table/ControlRoomTable";
import {WithApi, WithApiProperties} from "../../common/util/WithApi";
import {AOINotificationEvent} from "../model";
import {AOIEventsColumns} from "./AOIEventsColumns";

export const eventContentListDimensions = (parent: HTMLElement) => {
    return {
        width: parent.clientWidth,
        height: 8 * CONTROLROOM_TABLE_ROW_HEIGHT + CONTROLROOM_TABLE_HEADER_HEIGHT,
    };
};

const AOIEventsTable = createBasicTableComponent(AOIEventsColumns, eventContentListDimensions);

interface AOIEventsProps {
    notificationId: string;
    notificationAreaId: string;
    data: AOINotificationEvent[];
    isAllDataLoaded: boolean;
}

class AOIEventsListComponent extends React.Component<AOIEventsProps & InjectedIntlProps & WithApiProperties> {
    constructor(props) {
        super(props);
    }

    render() {
        const {intl, data, isAllDataLoaded} = this.props;

        return <AOIEventsTable
            {...this.props}
            intl={intl}
            data={data}
            isPaged={false}
            isAllDataLoaded={isAllDataLoaded}
            noItemsFoundMessage={<FormattedMessage id="studio.notifications.aoi-events-list.no-items"
                                                   defaultMessage="No AOI events found."/>}
            canMultiSelect={true}
        />
    }
}

export const AOIEventsList = WithApi(injectIntl(AOIEventsListComponent));